import {Component, HostBinding, OnInit} from '@angular/core';
import {GeneralService, SnackbarService} from 'app/core';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {Observable} from 'rxjs';
import {DeleteModalComponent} from 'app/components/delete-modal/delete-modal.component';
import {HttpErrorResponse} from '@angular/common/http';
import {StoresDataService} from 'app/domain/shops-wrapper/shops/services/stores.data.service';

@Component({
  selector: 'pr-shelf-page',
  templateUrl: './shelf-page.component.html',
  styleUrls: ['./shelf-page.component.scss']
})
export class ShelfPageComponent implements OnInit {

    @HostBinding('class') classes = 'flex flex-grow scroll-hide';

    id: number;
    meters: number;
    name: string;
    isDeleting = false;
    isLoading = false;

    constructor(
        public dataService: StoresDataService,
        public generalService: GeneralService,
        public snackbar: SnackbarService,
        private dialog: MatDialog,
        private router: Router,
        private _location: Location,
        private activatedRoute: ActivatedRoute,
    ) {
    }

    ngOnInit(): void {
        this.id = this.activatedRoute.snapshot.params.id as number;
        const createObs: Observable<any> = this.dataService.getShelf(this.id);
        this.isLoading = true;
        createObs
            .subscribe(
                res => {
                    this.name = res.Name;
                    this.meters = res.Meters;
                },
                () => {
                    this.snackbar.info('Wystąpił błąd podczas pobierania danych.');
                    this._location.back();
                },
                () => {
                    this.isLoading = false;
                }
            );
    }

    openDialog(): void {
        const dialogRef = this.dialog.open(DeleteModalComponent, {
            width: '250px',
            data: { name: this.name },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result.deleted) {
                this.delete();
            }
        });
    }

    navToEdit(): void {
        this.router.navigateByUrl(`metadata/settings/shelves/add/${this.id}`);
    }

    private delete() {
        this.isDeleting = true;
        this.dataService.deleteShelf(this.id)
            .subscribe(
                res => this.deleted(res),
                err => this.deleteError(err),
                () => this.isDeleting = false
            );
    }

    private deleted(response): void {
        this.snackbar.info(`Regał został usunięty.`);
        this.router.navigateByUrl('metadata/settings/shelves');
    }

    private deleteError(err: HttpErrorResponse) {
        this.isDeleting = false;
        if (err.status) {
            this.snackbar.info('Wystąpił błąd podczas usuwania.');
        }
    }
}
